import { Team } from './team';
import { Permission } from "./permission";
import { Tag } from './tag';
import { Feature } from './feature';
import { SuperScript } from './super-script';

export interface User {
    id: number;
    name: string;
    email: string;
    email_verified_at: Date;
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;
    teams: Team[];
    all_permissions: Permission[];
    leading_teams: Team[];
    invite_token: string;
    has_avatar: number;
    is_accepted_invite?: boolean;
    activated_2fa?: boolean;
    enabled_2fa?: boolean;
    is_mfa_required?: boolean;
    
    // for changing password
    new_password: string;
    old_password: string;

    pusher_key?: string;
    kibana_url? : string;
    company_id?: string;
    
    subscription_status?: SubscriptionStatus;
    
    account_status: AccountStatus;

    // key: permissionsName, inner string: 'all' | 'personal' | 'teams' | 'paths' | 'tags' | 'workflow_names'
    optimizedPermissions: any; // [string: { 'all': null } | { 'teams': Team[] } | { 'paths' : string[] } | { 'workflow_names': string[] } | { 'tags': Tag[] } ];
}

export interface SubscriptionStatus {
    trial_active?: boolean;
    trial_ends_at?: string;
    is_subscribed: boolean;
    subscribed_features?: Feature[];
    usage_features?: Feature[];
    monthly_special_discount_percent?: number;
    annual_special_discount_percent?: number;
    super_scripts?: SuperScript[];
}

export enum AccountStatus {
    ACCOUNT_STATUS_CREATING = 0,
    ACCOUNT_STATUS_ACTIVE = 1,
    ACCOUNT_STATUS_NEW_REGISTRATION = 2
}